export default function SectionContact() {
  return (
    <section id="contact" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-2xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
          联系我们
        </h2>
        <p className="text-sm text-foreground-500 mb-8">
          如有合作意向、资源投稿或问题反馈，欢迎通过以下方式联系我们
        </p>
        <div className="bg-background-50 rounded-lg border border-background-200 p-8">
          <div className="flex flex-col sm:flex-row items-center justify-center gap-8">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100">
                <i className="ri-mail-line text-primary-600 text-lg"></i>
              </div>
              <div className="text-left">
                <p className="text-xs text-foreground-400">投稿与合作</p>
                <p className="text-sm font-medium text-foreground-800">contact@tianlangyingyuan.com</p>
              </div>
            </div>
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100">
                <i className="ri-wechat-line text-accent-600 text-lg"></i>
              </div>
              <div className="text-left">
                <p className="text-xs text-foreground-400">官方微信</p>
                <p className="text-sm font-medium text-foreground-800">天狼影院官方号</p>
              </div>
            </div>
          </div>
          <p className="mt-6 text-xs text-foreground-400">
            工作时间：周一至周日 9:00 - 22:00，我们会在24小时内回复您的来信
          </p>
        </div>
      </div>
    </section>
  );
}